var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconHidehelp24 = function SvgAIconHidehelp24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 9L14 12L11 15",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.9998C18.0751 22.9998 23 18.0749 23 11.9998C23 5.92462 18.0751 0.999756 12 0.999756C5.92487 0.999756 1 5.92462 1 11.9998C1 18.0749 5.92487 22.9998 12 22.9998Z",
    strokeWidth: 1.5
  })));
};
export { SvgAIconHidehelp24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGQ9Ik0xMSA5TDE0IDEyTDExIDE1IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyIDIyLjk5OThDMTguMDc1MSAyMi45OTk4IDIzIDE4LjA3NDkgMjMgMTEuOTk5OEMyMyA1LjkyNDYyIDE4LjA3NTEgMC45OTk3NTYgMTIgMC45OTk3NTZDNS45MjQ4NyAwLjk5OTc1NiAxIDUuOTI0NjIgMSAxMS45OTk4QzEgMTguMDc0OSA1LjkyNDg3IDIyLjk5OTggMTIgMjIuOTk5OFoiIHN0cm9rZS13aWR0aD0iMS41IiAvPgo8L3N2Zz4=";